import { QueryClient } from '@tanstack/react-query';
import { Point } from '../../types';
import { PlacesSearchRequestDto, PlacesSearchResponseDto } from '../../types/dtos/places.dto';
import { apiClient } from '../apiClient';

export const searchPlaceByText = async (
  client: QueryClient,
  query: string,
  limit: number,
  referencePoint?: Point,
  boundingBox?: number[][]
): Promise<PlacesSearchResponseDto> => {
  if (limit <= 0) {
    return {
      data: {
        places: [],
      },
      message: 'success',
      metadata: {
        timestamp: new Date(),
        placesCount: 0,
        filters: {
          query: '',
          limit,
        },
      },
    };
  }

  // Use a higher limit of 10 for the benefit of the cache
  limit = limit < 10 ? 10 : limit;

  const requestBody: PlacesSearchRequestDto = {
    query,
    limit,
  };
  if (boundingBox) {
    // Prefer bounding box when available (i.e. most networks)
    requestBody.locationBias = {
      rectangle: {
        low: {
          longitude: boundingBox[0][0],
          latitude: boundingBox[0][1],
        },
        high: {
          longitude: boundingBox[1][0],
          latitude: boundingBox[1][1],
        },
      },
    };
  } else if (referencePoint) {
    // Create a circle bias around the reference point (viewport center)
    requestBody.locationBias = {
      circle: {
        center: {
          longitude: referencePoint.coordinates[0],
          latitude: referencePoint.coordinates[1],
        },
        radius: 10_000, // 10 km
      },
    };
  }

  return await client.fetchQuery({
    queryKey: ['places-search-by-text', requestBody],
    queryFn: async () => {
      const response = await apiClient.post('/v1/places/search-by-text', requestBody);
      return response.data as PlacesSearchResponseDto;
    },
    retry: false,
    staleTime: 1000 * 60 * 60 * 24, // 1 day
  });
};
